import React from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import SurveyInviteForm from '../../../components/forms/SurveyInviteForm';
import { useCreateSurveyInvite } from '../../../hooks/useSurveyInviteApi';
import { useNavigate } from 'react-router-dom';
import { SurveyInviteDTO } from '../../../services/apiClient';

const SurveyInviteCreate: React.FC = () => {
  const createSurveyInvite = useCreateSurveyInvite();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Survey Invites', href: '/admin/surveyinvites' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: SurveyInviteDTO) => {
    try {
      await createSurveyInvite.mutateAsync(data);
      navigate('/admin/surveyinvites');
    } catch (error) {
      console.error('Error creating SurveyInvite:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/surveyinvites"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.SurveyInvite.Edit'
    >
      <SurveyInviteForm
        initialValues={{} as SurveyInviteDTO}
        onSubmit={handleSubmit}
        onCancel={() => navigate('/admin/surveyinvites')}
      />
    </AdminLayout>
  );
};

export default SurveyInviteCreate;
